import { render, staticRenderFns } from "./InnerGiftModal.vue?vue&type=template&id=0246450d&scoped=true"
import script from "./InnerGiftModal.vue?vue&type=script&lang=ts"
export * from "./InnerGiftModal.vue?vue&type=script&lang=ts"
import style0 from "./InnerGiftModal.vue?vue&type=style&index=0&id=0246450d&prod&lang=css"
import style1 from "./InnerGiftModal.vue?vue&type=style&index=1&id=0246450d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0246450d",
  null
  
)

export default component.exports